/**
 * Import da biblioteca "styled-components", que permite escrever 
 * CSS simples para os componentes sem acontecer conflitos com os 
 * nomes das clases, são escritos entre Tagged Templates Literals(``).
 */
 import styled from 'styled-components';
/**
 * Estilização do componente StyledPopoverOpacity
 */
 export const Wrap = styled.div`

   .opacity-control {
     padding: 4px 14px;
     display: flex;
     align-items: center;
     .text-opacity{
      padding-top: 6px;     
      font-size: 12px;
      line-height: 14px;
      color: #5E6366;
     }
     .left-addorn {
       position: absolute;
       top: 19px;
       left: 15px;
     }
     .MuiSlider-root {
       color: #3c71dd;
       .MuiSlider-rail {
         height: 1px;
         color: #797e82;
       }
       .MuiSlider-track {
         height: 1px;
       }
     }
     .opacity-value {
       display: flex;
       align-items: center;
       width: 41px;
       height: 20px;
       border: 0.5px solid #c4c4c4;
       padding: 3px;
       margin: 0 0 0 16px;

       input,
       span {
         font-family: Roboto;
         font-style: normal;
         font-weight: normal;
         font-size: 12px;
         line-height: 14px;
         color: #5e6366;
       }

       input {
         -moz-appearance: textfield;
         &::-webkit-inner-spin-button {
           appearance: none;
           margin: 0;
         }
         min-width: 0;
         border: none;
         text-align: right;
       }
     }
   }
   .layer {
    padding-top: 8px;
   }
   .fill{
    padding-bottom: 8px;
   }
   .line{      
      padding-top: 6px;
      margin-bottom: 6px;
      border-bottom: 1px solid #E6E6E6;
    }
`;